<template>
  <div class="table-responsive">
    <div class="d-flex flex-md-row flex-column justify-content-md-between align-items-center">
      <filter-bar @filter="onFilterSet"></filter-bar>
    </div>
    <vuetable
      ref="vuetable"
      :apiUrl="apiUrl"
      :apiMode="apiMode"
      :fields="tableFields"
      :data="tableData"
      :dataTotal="dataCount"
      :dataManager="dataManager"
      :css="css.table"
      data-path="data"
      v-bind:paginationPath="paginationPath"
      :appendParams="moreParams"
      :perPage="brStr"
      :datum="perPage"
      :token="token"
      :site="site"
      v-on:vuetable:cell-clicked="(...args)=>this.prikaziDetalje([args])"
      @vuetable:pagination-data="onPaginationData"
    >
      <template slot="status" slot-scope="props">
        <button
          class="btn btn-sm"
          :class="props.rowData.status === 'aktiviran' ? 'btn-success disabled' : 'btn-primary'"
          :disabled="props.rowData.status === 'aktiviran' || aktiviranjeUToku === props.rowData._id"
          @click.stop="aktiviraj(props.rowData)"
        >
          <span v-if="aktiviranjeUToku === props.rowData._id" class="fa fa-spinner fa-spin"></span>
          {{ props.rowData.status === 'aktiviran' ? 'Aktiviran' : 'Aktiviraj' }}
        </button>
      </template>
    </vuetable>

    <div class="d-flex justify-content-center mb-4">
      <vuetable-pagination
        ref="pagination"
        :css="css.pagination"
        :onEachSide="onEachSide"
        @vuetable-pagination:change-page="onChangePage"
      ></vuetable-pagination>
    </div>

  </div>
</template>

<script>
import Vue from "vue";
import Vuetable from "vuetable-2/src/components/Vuetable";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import LocalData from "./data/local-data";
import DataTableStyles from "./data/data-table-styles";
import FilterBar from "./datatable-components/FilterBar.vue";
import router from "../../router";
import { http } from "../../../config/config.js";
import { bus } from "../../main.js";

const originalData = LocalData.data;

export default {
  name: "uputnice-table",

  components: {
    FilterBar,
    Vuetable,
    VuetablePagination
  },
  props: {
    site: {
      type: String
    },
    token: {
      type: String
    },
    sekcija: {
      type: String
    },
    apiUrl: {
      type: String
    },
    tableFields: {
      type: Array,
      required: true
    },
    onEachSide: {
      type: Number,
      default() {
        return 2;
      }
    },
    apiMode: {
      type: Boolean,
      default() {
        return true;
      }
    },
    data: {
      type: Array
    },
    sortFunctions: {
      type: Object
    },
    paginationPath: {
      type: String,
      default() {
        return "";
      }
    }
  },
  data() {
    return {
      tableData: LocalData,
      perPage: "",
      brStr: 10,
      colorClasses: {},
      moreParams: {},
      dataCount: 0,
      css: DataTableStyles,
      pacijent: {},
      show: true,
      potvrdi: "SAČUVAJ",
      odustani: "ZATVORI",
      patient_data: {},
      // Toasts
      toastText: "",
      toastIcon: "",
      toastPosition: "",
      toastDuration: 2500,
      isToastFullWidth: false,
      className: "",
      aktiviranjeUToku: null
    };
  },
  mounted() {
    this.onFilterSet(this.$store.state.filter);
    bus.$on("Set", data => {
      this.onFilterSet(data.ime + " " + data.prezime);
    });
  },
  beforeDestroy() {
    bus.$off("Set");
  },
  watch: {},
  methods: {
    unosPacijenta() {
      this.$refs.largeModalPatient.open();
    },
    prikaziDetalje: function(args) {

      var niz = args[0];

      if (
        args[0][2].srcElement.cellIndex === undefined &&
        !args[0][2].srcElement.classList.contains("disabled")
      ) {
        if (niz[1].name === "detalji") {
          this.pacijent = niz[0].id;
          this.Patient();
        }
        if (niz[1].name === "prijem") {
          router.push("/samples/" + args[0][0].id);
        }
       if (niz[1].name === "uputnice") {
          //router.push("/samples/" + args[0][0].id);
                console.log("niz[1].name")
      console.log(args[0])
       this.Uputnica(args[0][0].id);
        }
        // if (niz[1].name === "icon") {
        //   if(this.$store.state.access.level < 1){
        //     router.push("/evaluation/" + args[0][0].id);
        //   }           
        // }
      }
    },
    Patient() {
      http
        .get(
          "pacijenti/detalji/" +
            this.pacijent +
            "?token=" +
            this.$store.state.token +
            "&site=" +
            this.$store.state.site,
          {}
        )
        .then(res => {

          if (res.data.pacijent.jmbg != undefined) {
            this.patient_data = res.data.pacijent;
            this.$refs.modalPatientEdit.open();
          }
        });
    },
        Uputnica(id) {
      http
        .get("api/uputnica", {
          params: {
            identificatorValue: id,
            token: this.$store.state.token,
            site: this.$store.state.site
          }
        })
        .then(res => {
          if (res.data.success && res.data.data && res.data.data.results && res.data.data.results.length) {
            bus.$emit("GHealthUputnicaShow", res.data.data.results[0]);
          } else {
            this.showToast(res.data.message || "Uputnica nije pronađena.", {
              icon: "fa-warning",
              position: "top-right",
              duration: this.toastDuration,
              className: "vuestic-toast-warning"
            });
          }
        })
        .catch(() => {
          this.showToast("Greška pri pretraživanju uputnica.", {
            icon: "fa-remove",
            position: "top-right",
            duration: this.toastDuration,
            className: "vuestic-toast-danger"
          });
        });
    },
    onFilterSet(filterText, event) { 

      this.filterString = ""

      this.filterString = filterText
      
      if(event != undefined && filterText.trim() != ''){

        

         if (filterText.length === 14 && filterText.charAt(0) === "0") {
          
          filterText = filterText.replace(/^0/, "");
            console.log("Lična karta ili vozačka dozvola")
          } 

        

        if(!isNaN(filterText) && filterText.length == 13){
          if (this.apiMode) {
            this.moreParams = {
              filter: filterText
            };
          } else {
            const txt = new RegExp(filterText, "i");
            this.tableData.data = originalData.filter(function(item) {
              return item.name.search(txt) >= 0 || item.email.search(txt) >= 0;
            });
          }
          
          Vue.nextTick(() => this.$refs.vuetable.refresh());
          
        }else

        if(event.keyCode == 13){

          if (this.apiMode) {
            this.moreParams = {
              filter: filterText
            };
          } else {
            const txt = new RegExp(filterText, "i");
            this.tableData.data = originalData.filter(function(item) {
              return item.name.search(txt) >= 0 || item.email.search(txt) >= 0;
            });
          }
          
          Vue.nextTick(() => this.$refs.vuetable.refresh());
           this.Uputnica(filterText)
        }else{
          // console.warn('Waiting for Enter...')
        }

      }else{

        if (this.apiMode) {
          this.moreParams = {
            filter: filterText
          };
        } else {
          const txt = new RegExp(filterText, "i");
          this.tableData.data = originalData.filter(function(item) {
            return item.name.search(txt) >= 0 || item.email.search(txt) >= 0;
          });
        }
        Vue.nextTick(() => this.$refs.vuetable.refresh());
      }
    },
    aktiviraj(row) {
      this.aktiviranjeUToku = row._id;
      http
        .post("api/uputnica/activate", {
          token: this.$store.state.token,
          site: this.$store.state.site,
          protokol: row.uputnica
        })
        .then(res => {
          this.aktiviranjeUToku = null;
          if (res.data.success) {
            this.showToast("Uputnica uspješno aktivirana.", {
              icon: "fa-check",
              position: "top-right",
              duration: this.toastDuration,
              className: "vuestic-toast-primary"
            });
            Vue.nextTick(() => this.$refs.vuetable.refresh());
          } else {
            this.showToast(res.data.message || "Greška pri aktiviranju uputnice.", {
              icon: "fa-remove",
              position: "top-right",
              duration: this.toastDuration,
              className: "vuestic-toast-danger"
            });
          }
        })
        .catch(() => {
          this.aktiviranjeUToku = null;
          this.showToast("Greška pri konekciji sa serverom.", {
            icon: "fa-remove",
            position: "top-right",
            duration: this.toastDuration,
            className: "vuestic-toast-danger"
          });
        });
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    dataManager(sortOrder, pagination) {
      let data = this.tableData.data;
      let sortFunctions = this.sortFunctions;

      if (sortOrder.length > 0) {
        data.sort(function(item1, item2) {
          const sortField = sortOrder[0].sortField;
          let fn = sortFunctions[sortField];
          if (fn) {
            return fn(item1[sortField], item2[sortField]);
          }
        });

        if (sortOrder[0].direction === "desc") {
          data.reverse();
        }
      }

      pagination = this.$refs.vuetable.makePagination(data.length);

      return {
        pagination: pagination,
        data: data.slice(pagination.from - 1, pagination.to)
      };
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../sass/variables";
@import "../../sass/toasts";

@media (max-width: 1258px) {
  .pagination-link-btn:first-child,
  .pagination-link-btn:last-child {
    display: none;
  }
  .pagination-link-btn:nth-child(2) {
    border-top-left-radius: $btn-border-radius !important;
    border-bottom-left-radius: $btn-border-radius !important;
  }
  .pagination-link-btn:nth-last-child(2) {
    border-top-right-radius: $btn-border-radius !important;
    border-bottom-right-radius: $btn-border-radius !important;
  }
}

@media (max-width: 576px) {
  .hide-not-focused-btn:not(.focus) {
    display: none;
  }
}

.btn.btn-info {
  text-transform: none;
}
</style>



// WEBPACK FOOTER //
// src/components/02_uputnice/UputniceTable.vue